import { httpRequest } from "@services/http";

export class CommandRemoveEngagementContract {
  async run(engagementId: number): Promise<{ deleted: boolean }> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/contract/`;

    try {
      const response = await httpRequest<{ deleted: boolean }>(url, { method: "DELETE" });
      return response;
    } catch (error) {
      console.error(`Error removing contract from engagement ${engagementId}:`, error);
      throw error;
    }
  }
}